module.exports = __webpack_public_path__ + "static/bonus points-4b19927f7238ea060d08ac0c2189114f.wav";